import PlainModel from '@/modules/base/model/plain_model'

class ExpenseModel extends PlainModel {
  getVatDate() {
    const dateFor = this.props.deliveryDate || this.props.date
    return this.formatDate(dateFor)
  }
}
export default ExpenseModel
